import { OperacoesGeralService } from './../../../services/geral/operacoes/operacoes.geral.service';
import { takeWhile, catchError, take, timeout, finalize } from 'rxjs/operators';
import {
  Component,
  DoCheck,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FichaService } from '../../ficha-veiculo.service';
import { setFichaContent } from '../helpers/salvarFicha';
import { RecuperaAvalista } from '../model/recupera/recupera-avalista';
import { RecuperaCliente } from '../model/recupera/recupera-cliente';
import { FichaCadastro } from './../ficha-cadastro';
import { Assistencia } from './../model/assistencia';
import { Pessoa } from './../model/pessoa';
import { Proposta } from './../model/proposta';
import { Seguro } from './../model/seguro';
import { FichaCadastroSharedService } from './../shared/ficha-cadastro-shared.service';
import { DadoSimulacao } from './model/dado-simulacao';
import { AssistenciaSimulacao } from './model/proposta/assistencia-simulacao';
import { PropostaSimulacao } from './model/proposta/proposta-simulacao';
import { SeguroSimulacao } from './model/proposta/seguro-simulacao';
import { Parcela } from './parcela/parcela';
import { ModalMessageComponent } from './../../../shared/modais/modal-message/modal-message.component';
import { NewModalMessageComponent } from './../../../shared/modais/new-modal-message/new-modal-message.component';
import { of } from 'rxjs';
import { GrupoSeguro } from './model/proposta/grupo-seguro';
import { GrupoAssistencia } from './model/proposta/grupo-assistencia';
import { GrupoAssistenciaSelecionado } from './model/proposta/grupo-assistencia-selecionado';
import { GrupoSeguroSelecionado } from './model/proposta/grupo-seguro-selecionado';
import { VeiculoSimulacao } from './model/proposta/veiculo-simulacao';
import { cloneDeep } from 'lodash';
import { DadoSimulacaoSeguro } from './model/dado-simulacao-seguro';
import { SegurosService } from '../../seguros.service';
import { AssistanceType } from './model/proposta/assistance-types';
import { Assistance } from './model/proposta/all-assistances';
import { InsuranceGroups } from './model/proposta/insurance-groups';
import { TipoSeguro } from './model/proposta/all-insurances';
import { ParametroParcela } from './../../../services/parametro-parcela/parametro-parcela.interface';
import { LoginStorage } from '../../../login/login.storage';
import { ParametroParcelaService } from '../../../services/parametro-parcela/parametro-parcela.service';
import { SimuladorVeiculoTipoVeiculoEnum, TipoVeiculoEnum } from '../../../produtos/shared/enums/tipo-veiculo.enum';
import { TipoPagamentoEnum } from '../../../produtos/shared/enums/tipo-pagamrnto.enum';


@Component({
  selector: 'app-ficha-cadastro-resultado-parcial',
  templateUrl: './ficha-cadastro-resultado-parcial.component.html',
  styleUrls: ['./ficha-cadastro-resultado-parcial.component.css'],
})
export class FichaCadastroResultadoParcialComponent
  implements OnInit, OnDestroy, DoCheck
{
  @Input() fichaCadastro: FichaCadastro;
  @Input() isEtapa: boolean;

  @ViewChild('messageModal', { static: true })
  messageModal: NewModalMessageComponent;

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  @ViewChild('modelAttentionMessage', { static: true })
  modelAttentionMessage: ModalMessageComponent;

  private PARCELAS: number[] = [12, 18, 24, 36, 48, 60];
  private readonly PARCELAS_DEFAULT: number[] = [12, 18, 24, 36, 48, 60];
  private readonly PARCELAS_NORMAL_AMOUNT = 5;
  private readonly TAXA_CLIENTE_NOT_FOUND: string = 'TAXA_CLIENTE_NOT_FOUND';

  simulacao: DadoSimulacao = new DadoSimulacao();
  proposta: PropostaSimulacao = new PropostaSimulacao({});
  errorMessage: string;
  valorInicialSelecionado: number;

  isExecutandoSimulacao = false;
  isGettingFicha = false;
  parcelasSimuladas: Parcela[] = [];
  isPrimeiraVez = true;
  isSetAssistenciasDefault = true;
  isButtonNextDisabled = false;
  isParcelaSelecionada = true;
  pagamentoFlexivel = false;
  lojistaId: number;
  parametros: ParametroParcela | null = null;
  private isAlive = true;
  private isInitObservable = true;
  private isPossuiSimuacaoPendente = false;
  private quantidadeParcelasProcessadas = 0;

  public todosGruposSeguros: InsuranceGroups[] = [];
  public todosGruposAssistencias: AssistanceType[] = [];
  public todosSeguros: TipoSeguro[] = [];
  public todasAssistencias: Assistance[] = [];
  public veiculos = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly fichaService: FichaService,
    private readonly sharedService: FichaCadastroSharedService,
    private readonly operacoesGeralService: OperacoesGeralService,
    private readonly seguroService: SegurosService,
    private readonly router: Router,
    private parametroParcelaService: ParametroParcelaService,
    private loginStorage: LoginStorage,
  ) {}

  ngOnInit() {
    this.initObservableResultadoParcial();
  }

  preencheAssistencias() {
    const grupoSeguroSelecionado = this.simulacao.seguro.gruposSeguroIds;
    const grupoAssistenciaSelecionado =
      this.simulacao.seguro.gruposAssistenciaIds[0];

    const gruposAssistenciasPorTipo = cloneDeep(
      this.proposta.gruposAssistencias
    );

    gruposAssistenciasPorTipo.map((grupoAssistencia) => {
      grupoAssistencia.assistencias = grupoAssistencia.assistencias.filter(
        (assistencia) => assistencia.tipo === this.getTipoVeiculo()
      );
    });

    const seguro = new DadoSimulacaoSeguro();
    seguro.setRetorno(this.simulacao.seguro.retorno);
    if (grupoSeguroSelecionado.length > 0) {
      seguro.setGrupoSeguroIds(grupoSeguroSelecionado);
    }
    if (grupoAssistenciaSelecionado && grupoAssistenciaSelecionado.length > 0) {
      seguro.setGrupoAssistenciaIds(
        grupoAssistenciaSelecionado.map((g) => ({
          ...g,
          tipoVeiculo: this.getTipoVeiculo(),
        })),
        0
      );
    }

    this.simulacao.setSeguro(seguro);
  }

  ngDoCheck() {
    if (this.isAlive && this.fichaCadastro.getFichaLocalStorage) {
      this.isAlive = false;
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
    this.isInitObservable = false;
  }

  private initObservableResultadoParcial() {
    this.sharedService.resultadoParcialObservable
      .pipe(takeWhile(() => this.isInitObservable))
      .subscribe(this.initView.bind(this));
  }

  simularProposta(id: string) {
    this.fichaService
      .getDadosProposta(id)
      .pipe(catchError((err) => of(this.handleErrorSimulacao(err))))
      .subscribe((result) => this.handleResultDadoSimulacao(result));
  }

  private handleResultDadoSimulacao(result) {
    this.lojistaId = result.lojista.id;
    if (result.proposta && result.proposta.id) {
      this.simulacao.setNumeroProposta(result.proposta.id);
    }
    this.initView(result);
  }

  private handleErrorSimulacao(err) {
    const error = err.error || err;
    this.isExecutandoSimulacao = false;
    if (error.status === this.TAXA_CLIENTE_NOT_FOUND) {
      this.handleErroTaxaClienteNaoEncontrada(error);
    } else {
      this.handleErroInesperado();
    }
  }

  private handleErroTaxaClienteNaoEncontrada(error: any) {
    this.showErrorMessage(error.message, () => this.home());
  }

  private handleErroInesperado() {
    this.messageModal.showModal({
      mensagem: 'Ocorreu um erro inesperado ao buscar os dados da simulação.',
      titulo: 'Atenção!',
    });
  }

  private initView(result) {
    this.proposta = new PropostaSimulacao(result);
    this.setDataAvalista(result);
    this.getRendaCliente(result);
    this.getRendaAvalista(result);
    this.fichaCadastro.setTipoVeiculo(result.tipoProduto);
    this.fichaCadastro._client.cpf = this.proposta.cliente.getCpf();
    this.proposta.getTaxaClinte().retornoMax = result.taxaCliente
      ? result.taxaCliente.retornoMax
      : 0;
    this.loadInfoCliente();
    const avalistas = this.proposta.getAvalistas();
    if (
      (avalistas && avalistas.length > 0) ||
      (this.fichaCadastro.recoverData &&
        this.fichaCadastro.recoverData.proposal.guarantors.length > 0)
    ) {
      this.fichaCadastro.setAvalista(true);
    } else {
      this.fichaCadastro.setAvalista(false);
    }

    if (result.status === 'VEICULOS_PENDENTE') {
      const payload = this.proposta.toPayload();
      this.fichaCadastro.replacePayload(payload);
      this.fichaCadastro.veiculosGetDados = this.proposta.veiculos;
      this.fichaCadastro.veiculosPendencia = this.proposta.veiculosPendencia;
      this.mergeVeiculoPendenciaGetDados();
      this.fichaCadastro.setIdSimulacao(this.proposta.getIdSimulacao());
      this.fichaCadastro.setPasso(this.fichaCadastro.PASSO_VEICULO);
      this.sharedService.verificaPendenciaVeiculo();
      return;
    }

    this.simulacao.init(this.proposta);
    this.valorInicialSelecionado = this.simulacao.getValor();
    this.iniciarSimulacoes();
    this.unsetIsGettingFicha();
    this.fichaCadastro.grupo1 = result.grupo1;
    this.getRendaPorGrupo();
    this.fichaCadastro.garantias = result.veiculos.map((veiculo) => {
      return {
        anoModelo: veiculo.anoModelo,
        descMarcaModelo: `${veiculo.marca.descricao} ${veiculo.modelo.descricao}`,
        descVersao: veiculo.versao.descricao,
      };
    });
    this.fichaCadastro.garantiasOriginais = this.fichaCadastro.garantias;

    this.fichaCadastro.veiculoProprio = this.proposta.veiculoProprio;
    this.preencheAssistencias();
    this.getParcelaFlexivel(); 
  }

  getRendaPorGrupo() {
    this.operacoesGeralService
      .produtosPorUsuario(this.fichaCadastro.grupo1)
      .pipe(
        timeout(20000),
        take(1),
        finalize(() => setFichaContent(this.fichaCadastro))
      )
      .subscribe((res) => {
        [this.fichaCadastro.limiteRenda] = this.limiteRenda(res);
      });
  }

  limiteRenda(res) {
    return res.filter((item) => {
      return (
        item.descricao
          .toUpperCase()
          .normalize('NFD')
          .replace(/[^a-zA-Zs]/g, '') === this.fichaCadastro.veiculoTipo
      );
    });
  }

  private mergeVeiculoPendenciaGetDados(): void {
    const placasVeiculos = this.fichaCadastro.veiculosGetDados
      .map((m) => m.placa)
      .filter((f) => f);
    this.fichaCadastro.veiculosPendencia.forEach((veiculoPendencia) => {
      if (
        veiculoPendencia.placa &&
        !placasVeiculos.includes(veiculoPendencia.placa)
      ) {
        const modelInput = veiculoPendencia.principal ? 'unshift' : 'push';
        this.fichaCadastro.veiculosGetDados[modelInput](
          new VeiculoSimulacao({ placa: veiculoPendencia.placa })
        );
      }
    });
  }

  private handleErrorInitView(result) {
    if (result.proposta && result.veiculos && result.taxaCliente) {
      this.initView(result);
    } else {
      this.errorMessage = result.error.message;
    }
  }

  setDataAvalista(data) {
    if (
      data.avalistas instanceof Array &&
      data.avalistas.length > 0 &&
      (this.fichaCadastro.setDadosAvalistas.every((i) => i) ||
        this.fichaCadastro.recoverData.proposal.guarantors.length === 0)
    ) {
      this.fichaCadastro.avalistas = data.avalistas.map((avalista) => {
        return new RecuperaAvalista(avalista).$avalista;
      });
    }
  }

  getRendaCliente(data) {
    if (data.cliente) {
      this.fichaCadastro.rendaCliente = data.cliente.renda;
    }
  }

  getRendaAvalista(data) {
    if (data.avalistas) {
      this.fichaCadastro.rendaAvalista = data.avalistas.renda;
    }
  }

  loadInfoCliente() {
    this.fichaService
      .recuperarDadosFicha(
        this.formatCpf(this.fichaCadastro._client.cpf),
        this.fichaCadastro.IDLojista
      )
      .subscribe(
        (res) => {
          this.varificaTipoPessoa(res.clientes);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  varificaTipoPessoa(data) {
    if (!data) {
      return console.log(new Error('não recebeu nenhum dado '));
    }

    data.forEach((item) => {
      if (
        item.tipo === 'CLIENTE' &&
        !this.fichaCadastro.getFichaLocalStorage &&
        this.fichaCadastro.shoudInitializeCustomer
      ) {
        this.fichaCadastro._client = new RecuperaCliente(item).$client;
      } else if (
        item.tipo === 'AVALISTA' &&
        !this.fichaCadastro.getFichaLocalStorage &&
        this.fichaCadastro.setDadosAvalistas.every((i) => i)
      ) {
        this.fichaCadastro._avalista = new RecuperaAvalista(item).$avalista;
      }
    });
  }

  formatCpf(data) {
    if (data) {
      return data.replace(/[\.\-]/g, '');
    }
  }

  iniciarSimulacoes() {
    if (!this.isExecutandoSimulacao) {
      this.isPossuiSimuacaoPendente = false;
      this.quantidadeParcelasProcessadas = 0;
      this.proposta;
      this.simularSeguroRouboFurto();
    } else {
      this.isPossuiSimuacaoPendente = true;
    }
  }

  simularSeguroRouboFurto() {
    this.seguroService
      .createCotacao(this.simulacao.getNumeroProposta())
      .pipe(
        take(1),
        finalize(() => this.simularDetalhe())
      )
      .subscribe();
  }

  simularDetalhe() {
    this.isExecutandoSimulacao = true;
    if (this.isPrimeiraVez) {
      this.simulacao.getSeguro().setGrupoAssistenciaIds([], 0);
      this.simulacao.getSeguro().setGrupoSeguroIds([]);
    }
    this.fichaService
      .simulacaoDetalhe(this.simulacao, 0)
      .pipe(
        takeWhile(() => this.isExecutandoSimulacao),
        finalize(() => (this.isExecutandoSimulacao = false))
      )
      .subscribe(
        (result) => {
          this.PARCELAS = [...this.PARCELAS_DEFAULT];
          this.validaParcelas(result);
        },
        (error) => this.handleSimulacaoError(error)
      );
  }

  async getAllSeguros(resultadoSimulacao) {
    this.isExecutandoSimulacao = true;
    if (resultadoSimulacao.seguros && resultadoSimulacao.seguros.length > 0) {
      await this.obterGruposSeguro();
      await this.obterSeguros();
      this.handlerSegurosResult(resultadoSimulacao);
    } else {
      this.proposta.gruposSeguros = [];
      this.getAllAssistencias(resultadoSimulacao);
    }
  }

  async obterSeguros() {
    const seguros = await this.fichaService.getAllSeguros().toPromise();

    if (!seguros) {
      this.messageModal.showModal({
        titulo: 'Atenção!',
        mensagem:
          'Ocorreu um erro inesperado ao obter os Seguros, tente novamente.',
      });
      return;
    }

    this.todosSeguros = seguros.tiposSeguro;
  }

  async obterGruposSeguro() {
    const gruposSeguro = await this.fichaService
      .getAllGrupoSeguro()
      .toPromise();
    this.todosGruposSeguros = gruposSeguro.insuranceGroups || [];

    if (!this.todosGruposSeguros) {
      this.messageModal.showModal({
        titulo: 'Atenção!',
        mensagem:
          'Ocorreu um erro inesperado ao obter os Grupos Seguro, tente novamente.',
      });
    }
  }

  async obterGruposAssistencia() {
    const todosTipoAssistencia = await this.fichaService
      .getAllTipoAssistencia()
      .toPromise();

    this.todosGruposAssistencias = todosTipoAssistencia.assistanceTypes || [];

    if (!this.todosGruposAssistencias) {
      this.messageModal.showModal({
        titulo: 'Atenção!',
        mensagem:
          'Ocorreu um erro inesperado ao obter os Grupos Assistencias, tente novamente.',
      });
    }
  }

  async obterAssistencias() {
    const assistenciasResponse = await this.fichaService
      .getAllAssistencias(this.getTipoVeiculo())
      .toPromise();
    this.todasAssistencias = assistenciasResponse.assistances || [];

    if (!this.todasAssistencias) {
      this.messageModal.showModal({
        titulo: 'Atenção!',
        mensagem:
          'Ocorreu um erro inesperado ao obter os Assistencias, tente novamente.',
      });
    }
  }

  async getAllAssistencias(resultadoSimulacao) {
    this.proposta.assistencias = [];
    await this.obterGruposAssistencia();
    await this.obterAssistencias();

    if (
      resultadoSimulacao.assistencias &&
      resultadoSimulacao.assistencias.length > 0
    ) {
      this.handlerAssistenciasResult(resultadoSimulacao);
    } else {
      this.isExecutandoSimulacao = false;
    }
  }

  validaParcelas(result) {
    this.isButtonNextDisabled = false;
    if (result.parcelamentos.length === 0) {
      this.handleErrorSemParcelamento();
      this.parcelasSimuladas = [];
    } else if (result.parcelamentos.length < this.PARCELAS.length) {
      if (result.parcelamentos.length < this.PARCELAS_NORMAL_AMOUNT) {
        if (
          result.parcelamentos[result.parcelamentos.length - 1].parcelas !== 60
        ) {
          this.PARCELAS.pop();
        }
        this.handleErrorParcelamentoIndisponivel();
      } else {
        this.PARCELAS.pop();
      }
      this.montaParcelas(result);
    } else {
      this.montaParcelas(result);
    }
  }

montaParcelas(result: any) {
      this.isPrimeiraVez = false;
      this.montaParcelasVazio();
      const parcelaSelecionada = cloneDeep(this.simulacao.parcelas);
      this.parcelasSimuladas = result.parcelamentos.map((parcela: any) => {
        const parcelaAdd = new Parcela();
        parcelaAdd.setQuantidade(parcela.parcelas);
        parcelaAdd.setValor(parcela.valorParcela);
        parcelaAdd.setExibir(true);
        parcelaAdd.setTaxa(parcela.taxa);
        parcelaAdd.setValorTotal(parcela.valorTotal);
        parcelaAdd.setFator(parcela.fator);
        parcelaAdd.setDataCarenciaMaxima(parcela.dataCarenciaMaxima);
        parcelaAdd.setDataCarenciaMinima(parcela.dataCarenciaMinima);
        parcelaAdd.setPeriodicidadePagamento(parcela.periodicidadePagamento);
        parcelaAdd.setPrazoMeses(parcela.getPrazoMeses);

   if (parcela.parcelasFlexiveis?.length) {
          parcelaAdd.setParcelasFlexiveis(
            parcela.parcelasFlexiveis.map((flex: any) => {
              const flexivel = new Parcela();
              flexivel.setQuantidade(flex.parcelas);
              flexivel.setValor(flex.valorParcela);
              flexivel.setTaxa(flex.taxa);
              flexivel.setFator(flex.fator);
              flexivel.setValorTotal(flex.valorTotal);
              flexivel.setDataCarenciaMinima(flex.dataCarenciaMinima);
              flexivel.setDataCarenciaMaxima(flex.dataCarenciaMaxima);
              flexivel.setPeriodicidadePagamento(flex.periodicidadePagamento);
              flexivel.setPrazoMeses(flex.prazoMeses);
              flexivel.setExibir(true);          
              return flexivel;
            })
          );
        }
        if (
          !parcelaSelecionada ||
          parcelaSelecionada === parcelaAdd.getQuantidade()
        ) {
          this.simulacao.parcelas = parcelaAdd.getQuantidade();
          this.proposta.getTaxaClinte().valorParcela = parcelaAdd.getValor();
          this.proposta.getTaxaClinte().parcelas = parcelaAdd.getQuantidade();
          this.proposta.getTaxaClinte().fator = parcelaAdd.getFator();
          this.proposta.getTaxaClinte().periodicidadePagamento = parcelaAdd.getPeriodicidadePagamento();
          if(this.proposta.getTaxaClinte().periodicidadePagamento === 1 ){
            this.proposta.getTaxaClinte().tipoPagamento = TipoPagamentoEnum.MENSAL;
          }else{
            this.proposta.getTaxaClinte().tipoPagamento = TipoPagamentoEnum.FLEXIVEL;
          }
          this.proposta.getTaxaClinte().prazoMeses = parcelaAdd.getPrazoMeses();
        }

        return parcelaAdd;
      });

      this.parcelasSimuladas.sort(
        (a, b) => a.getQuantidade() - b.getQuantidade()
      );

      this.carregaDadosDetalhe(result);
      this.getAllSeguros(result);
}

  carregaDadosDetalhe(result) {
    this.proposta.getTaxaClinte().parcelaMax = result.valorMaxParcela;
    this.proposta.getTaxaClinte().valorRegistro = result.valorRegistro;
    this.proposta.getTaxaClinte().valorSircof = result.valorSircof;
    this.proposta.getTaxaClinte().valorTc = result.valorTc;
    this.proposta.getTaxaClinte().valorDv = result.valorDv;
    this.proposta.getTaxaClinte().entrada = result.valorEntrada;
    this.proposta.getTaxaClinte().valorLiquido = result.valorLiquido;
    this.proposta.getTaxaClinte().valorRetorno = result.valorRetorno;
    this.proposta.getTaxaClinte().periodicidadePagamento = result.periodicidadePagamento;
    this.proposta.getTaxaClinte().prazoMeses = result.prazoMezes;
    this.proposta.getTaxaClinte().taxaFinal = result.taxaFinal;
    this.proposta.getTaxaClinte().valorLiberado = result.valorLiberado;
       if(this.proposta.getTaxaClinte().periodicidadePagamento === 1 ){
            this.proposta.getTaxaClinte().tipoPagamento = TipoPagamentoEnum.MENSAL;
          }else{
            this.proposta.getTaxaClinte().tipoPagamento = TipoPagamentoEnum.FLEXIVEL;
          }
  }

  montaParcelasVazio() {
    this.parcelasSimuladas = [];
    this.PARCELAS.forEach((opcao: number) => {
      const parcelaAdd = new Parcela();
      this.parcelasSimuladas.push(parcelaAdd);
    });
    this.isExecutandoSimulacao = false;
  }

  handlerSegurosResult(resultadoSimulacao) {
    const seguroSelecionadosDefault: GrupoSeguroSelecionado[] = [];
    this.proposta.gruposSeguros = [];
    resultadoSimulacao.seguros.forEach((grupoSeguroSimulacao: any) => {
      const grupoSeguro = new GrupoSeguro();
      grupoSeguro.id = grupoSeguroSimulacao.id;
      grupoSeguro.descricao = this.todosGruposSeguros.find(
        (o) => o.id === grupoSeguro.id
      ).description;
      grupoSeguro.seguros = [];

      grupoSeguroSimulacao.items.forEach(
        (grupoSeguroSimulacaoCadaSeguro: any) => {
          const seguro: any = new Object();
          seguro.id = grupoSeguroSimulacaoCadaSeguro.id;
          seguro.valor = grupoSeguroSimulacaoCadaSeguro.valor;

          if (grupoSeguroSimulacaoCadaSeguro.selected) {
            seguroSelecionadosDefault.push(
              new GrupoSeguroSelecionado(
                grupoSeguroSimulacaoCadaSeguro.id,
                grupoSeguro.id
              )
            );
          }

          this.todosSeguros.forEach((seguroLista: TipoSeguro) => {
            if (seguroLista.id === grupoSeguroSimulacaoCadaSeguro.id) {
              seguro.descricao = seguroLista.descricaoAPP;
              seguro.percentual = seguroLista.percentual;
              seguro.valorMaximo = seguroLista.valorMaximoParc;
              seguro.saibaMais = seguroLista.saibaMais;
            }
          });

          grupoSeguro.seguros.push(new SeguroSimulacao(seguro));
        }
      );

      this.proposta.gruposSeguros.push(grupoSeguro);
    });

    let auxSeguroSelecionadosDefault = seguroSelecionadosDefault;
    if (!seguroSelecionadosDefault || !seguroSelecionadosDefault.length) {
      auxSeguroSelecionadosDefault = this.proposta.gruposSeguros.map((g) => ({
        grupoId: g.id,
        seguroId: 0,
      }));
    }
    this.simulacao.getSeguro().setGrupoSeguroIds(auxSeguroSelecionadosDefault);
    this.getAllAssistencias(resultadoSimulacao);
  }

  handlerAssistenciasResult(resultadoSimulacao) {
    const assistenciasSelecionadosDefault: GrupoAssistenciaSelecionado[] = [];
    this.proposta.gruposAssistencias = [];
    resultadoSimulacao.assistencias.forEach(
      (grupoAssistenciaSimulacao: any) => {
        // Cria Grupo Assistencia

        const grupoAssistencia = new GrupoAssistencia();
        grupoAssistencia.id = grupoAssistenciaSimulacao.id;
        const grupoAssistenciaAux = this.todosGruposAssistencias.find(
          (o) => o.id === grupoAssistencia.id
        );
        if (grupoAssistenciaAux) {
          grupoAssistencia.descricao = grupoAssistenciaAux.description;
          grupoAssistencia.nivel = grupoAssistenciaAux.level;
        }
        grupoAssistencia.assistencias = [];

        grupoAssistenciaSimulacao.items.forEach((grupoCadaAssistencia: any) => {
          const assistencia: any = new Object(); // assistencia
          assistencia.id = grupoCadaAssistencia.id;

          if (grupoCadaAssistencia.selected) {
            assistenciasSelecionadosDefault.push(
              new GrupoAssistenciaSelecionado(
                grupoCadaAssistencia.id,
                grupoAssistencia.id
              )
            );
          }

          this.todasAssistencias.forEach((assistenciaLista: Assistance) => {
            if (assistenciaLista.id === grupoCadaAssistencia.id) {
              assistencia.descricao = assistenciaLista.appDescription;
              assistencia.saibaMais = assistenciaLista.learnMoreDescription;
              assistencia.valor = assistenciaLista.value;
              // enquanto as propostas só tiverem 1 tipo de veiculo
              assistencia.tipo = this.getTipoVeiculo();
              grupoAssistencia.assistencias.push(
                new AssistenciaSimulacao(assistencia)
              ); // add seguro para o grupo
            }
          });
        });
        this.proposta.gruposAssistencias.push(grupoAssistencia);
      }
    );

    if (this.isSetAssistenciasDefault) {
      const grupoIdGarantia = this.proposta.gruposAssistencias.find(
        (f) => f.nivel === 'GARANTIA'
      );
      this.proposta.veiculos.forEach((_, indexVeiculo) => {
        if (!indexVeiculo) {
          this.simulacao
            .getSeguro()
            .setGrupoAssistenciaIds(
              assistenciasSelecionadosDefault,
              indexVeiculo
            );
        } else {
          this.simulacao.getSeguro().setGrupoAssistenciaIds(
            assistenciasSelecionadosDefault.filter(
              (f) => grupoIdGarantia && f.grupoId === grupoIdGarantia.id
            ),
            indexVeiculo
          );
        }
      });
      this.isSetAssistenciasDefault = false;
    }

    this.isExecutandoSimulacao = false;
  }

  handleSimulacaoError(error) {
    this.messageModal.showModal({
      mensagem:
        'Ocorreu um erro inesperado em nossos servidores, tente novamente.',
      titulo: 'Atenção!',
    });
    this.home();
  }

  handleErrorSemParcelamento() {
    this.messageModal.showModal({
      mensagem: 'Parcelamento não disponível para o valor selecionado.',
      titulo: 'Atenção!',
    });
    this.montaParcelasVazio();
    this.isButtonNextDisabled = true;
  }

  handleErrorParcelamentoIndisponivel() {
    this.messageModal.showModal({
      mensagem: 'Algumas opções de parcelamento não disponíveis.',
      titulo: 'Atenção!',
    });
  }

  onChangeSeguro(seguro) {
    this.simulacao.setSeguro(seguro);
    this.iniciarSimulacoes();
  }

  onChangeAssistencia(seguro, index) {
    this.simulacao
      .getSeguro()
      .setGrupoAssistenciaIds(seguro.gruposAssistenciaIds[index], index);
    this.iniciarSimulacoes();
  }

  onChangeValorSimular(valor) {
    if (this.simulacao.getValor() !== valor) {
      this.simulacao.setValor(valor);
      this.isExecutandoSimulacao = false;
      this.simularDetalhe();
    }
  }

  onChangeParcela(simular) {
    if (simular) {
      this.iniciarSimulacoes();
    }
  }

  onUpdateVeiculo() {
    this.isExecutandoSimulacao = false;
    this.isPossuiSimuacaoPendente = false;
  }

  getCotacao() {
    let cotacaoMax = 0;
    this.proposta.veiculos.forEach(
      (veiculo) => (cotacaoMax += veiculo.cotacao)
    );

    return cotacaoMax || 0;
  }

  getTipoVeiculo() {
    if (this.proposta.veiculos && this.proposta.veiculos.length) {
      return this.proposta.veiculos[0].grupo2;
    }
  }

  onClickNext() {
    if (
      this.proposta.taxaCliente &&
      this.proposta.taxaCliente.retornoMax > 0 &&
      this.simulacao.seguro.retorno === 0
    ) {
      this.showAttentionMessageZeroStar(
        'O valor das Estrelas estão igual a ZERO. Deseja continuar mesmo assim ?'
      );
      return;
    }

    this.initializeGoToNextTab();
  }

  private initializeGoToNextTab() {
    const propostaSimulada = this.proposta;
    const propostaEncerrar = this.translateProposta(propostaSimulada);
    this.translateSeguro(propostaEncerrar);
    this.translateAssistencia(propostaEncerrar);
    this.translateCliente(propostaSimulada, propostaEncerrar);
    this.translateAvalistas(propostaSimulada, propostaEncerrar);
    this.fichaCadastro.initializeProposta(propostaEncerrar);
    setFichaContent(this.fichaCadastro);
    this.fichaCadastro.onClickNext();
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  private translateProposta(propostaSimulada: PropostaSimulacao): Proposta {
    const taxaClienteSimulada = propostaSimulada.getTaxaClinte();
    const propostaEncerrar = new Proposta();

    propostaEncerrar.setId(propostaSimulada.getId());

    if (taxaClienteSimulada.getCarencia()) {
      propostaEncerrar.setCarencia(taxaClienteSimulada.getCarencia());
    } else {
      propostaEncerrar.setCarencia(this.simulacao.getCarencia());
    }

    propostaEncerrar.setValorEntrada(taxaClienteSimulada.getEntrada());
    propostaEncerrar.setValorTotal(taxaClienteSimulada.getValorLiberado());
    propostaEncerrar.setValorLiquido(taxaClienteSimulada.getValorLiquido());
    propostaEncerrar.setPercRetorno(
      this.simulacao.getSeguro().getPercRetorno()
    );
    propostaEncerrar.setValorParcela(taxaClienteSimulada.getValorParcela());
    propostaEncerrar.setQtdParcelas(taxaClienteSimulada.getParcelas());
    propostaEncerrar.setFator(taxaClienteSimulada.getFator());
    propostaEncerrar.setTaxaProposta(taxaClienteSimulada.getTaxaFinal());
    propostaEncerrar.setValorRegistro(taxaClienteSimulada.getValorRegistro());
    propostaEncerrar.setValorSircof(taxaClienteSimulada.getValorSircof());
    propostaEncerrar.setValorTc(taxaClienteSimulada.getValorTc());
    propostaEncerrar.setValorDv(taxaClienteSimulada.getValorDv());
    propostaEncerrar.setValorEntrada(taxaClienteSimulada.getEntrada());
    propostaEncerrar.setValorRetorno(taxaClienteSimulada.getValorRetorno());
    propostaEncerrar.setTaxaNormalizada(taxaClienteSimulada.getTaxaNormalizada())
    propostaEncerrar.setTipoPagamento(taxaClienteSimulada.getIipoPagamento())
    propostaEncerrar.setPeriodicidadePagamento(taxaClienteSimulada.getPeriodicidadePagamento())
    propostaEncerrar.setPrazoMeses(taxaClienteSimulada.getPrazoMeses())
    this.proposta.taxaCliente.seguro = taxaClienteSimulada.getSeguro();
    return propostaEncerrar;
  }

  private translateSeguro(propostaEncerrar: Proposta): void {
    const segurosIds = this.simulacao
      .getSeguro()
      .getGrupoSeguroIds()
      .map((elem) => elem.seguroId);

    if (
      segurosIds &&
      segurosIds.length > 0 &&
      this.proposta.gruposSeguros.length > 0
    ) {
      const segurosParaAdicionar = [];

      this.proposta.gruposSeguros.forEach((grupo) => {
        grupo.seguros.forEach((seguro) => {
          if (segurosIds.includes(seguro.id)) {
            segurosParaAdicionar.push(new Seguro(seguro.id, seguro.valor));
          }
        });
      });

      propostaEncerrar.setSeguro(segurosParaAdicionar);
    }
  }

  private translateAssistencia(propostaEncerrar: Proposta): void {
    const assistenciasIds = [];

    this.simulacao
      .getSeguro()
      .getGrupoAssistenciaIds()
      .forEach((grupoAssistencia, indexB) => {
        if (grupoAssistencia && grupoAssistencia.length) {
          grupoAssistencia.forEach((ga) =>
            assistenciasIds.push({
              assistenciaId: ga.assistenciaId,
              bem: indexB + 1,
              tipoVeiculo: ga.tipoVeiculo || this.getTipoVeiculo(),
            })
          );
        }
      });

    if (
      assistenciasIds &&
      assistenciasIds.length > 0 &&
      this.proposta.gruposAssistencias.length > 0
    ) {
      const assistenciaParaAdicionar = [];

      assistenciasIds.forEach((value) => {
        this.proposta.gruposAssistencias.forEach((grupo) => {
          grupo.assistencias.forEach((assist) => {
            if (
              value.assistenciaId === assist.id &&
              value.tipoVeiculo === assist.tipo
            ) {
              assistenciaParaAdicionar.push(
                new Assistencia(assist.id, assist.valor, value.bem)
              );
            }
          });
        });
      });

      propostaEncerrar.setAssistencia(assistenciaParaAdicionar);
    }
  }

  private translateCliente(
    propostaSimulada: PropostaSimulacao,
    propostaEncerrar: Proposta
  ) {
    const clienteSimulado = propostaSimulada.getCliente();
    const cliente = new Pessoa();
    cliente.setId(clienteSimulado.getId());
    cliente.setCpf(clienteSimulado.getCpf());
    cliente.setNome(clienteSimulado.getNome());
    cliente.setNomeMae(clienteSimulado.getNomeMae());
    cliente.setRenda(clienteSimulado.getRenda());
    cliente.setEmail(clienteSimulado.getEmail());
    cliente.setNomePai(clienteSimulado.getNomePai());
    cliente.setTelefones(clienteSimulado.getTelefones());
    cliente.setIdNacionalidade(clienteSimulado.getIdNacionalidade());
    cliente.setNaturalDe(clienteSimulado.getNaturalDe());
    cliente.setNaturalDeUf(clienteSimulado.getNaturalDeUf());
    cliente.setEnderecos(clienteSimulado.getEnderecos());
    cliente.setValorPatrimonio(clienteSimulado.getValorPatrimonio());
    cliente.setIdEstadoCivil(clienteSimulado.getIdEstadoCivil());
    cliente.setSexo(clienteSimulado.getSexo());
    cliente.setDocumento(clienteSimulado.getDocumento());
    cliente.setClientePpe(clienteSimulado.getPpe() ? 'S' : 'N');
    cliente.setFatca(clienteSimulado.getFatca() ? true : false);
    cliente.setDadoProfissional(clienteSimulado.getProfissional());
    cliente.setClienteReferencia(clienteSimulado.getReferencia());

    propostaEncerrar.setCliente(cliente);
    this.fichaCadastro._client.nome = clienteSimulado.getNome();
    this.fichaCadastro._client.nomeMae = clienteSimulado.getNomeMae();
  }

  private translateAvalistas(
    propostaSimulada: PropostaSimulacao,
    propostaEncerrar: Proposta
  ) {
    const avalistasSimulado = propostaSimulada.getAvalistas();
    if (avalistasSimulado && avalistasSimulado.length > 0) {
      this.fichaCadastro.setAvalista(true);
      const avalistas = avalistasSimulado.map((obj) => {
        const avalista = new Pessoa();
        avalista.setId(obj.getId());
        avalista.setCpf(obj.getCpf());
        avalista.setDataNascimento(obj.getDataNascimento());
        avalista.setRenda(obj.getRenda());
        avalista.setTelefones(obj.getTelefones());
        avalista.setVeiculoProprio(obj.getVeiculoProprio());
        avalista.setGrauParentescoCliente(obj.getGrauParentesco());

        return avalista;
      });
      propostaEncerrar.setAvalistas(avalistas);
    }
  }

  setIsGettingFicha() {
    this.isGettingFicha = true;
  }

  unsetIsGettingFicha() {
    this.isGettingFicha = false;
  }

  private showErrorMessage(message: string, next: () => void) {
    this.modalMessage.show(message).modalClose.pipe(take(1)).subscribe(next);
  }

  private showAttentionMessageZeroStar(message: string) {
    this.modelAttentionMessage.show(message).modalClose.pipe(take(1));
  }

  public onReturnContinueAttentionMessageZeroStar() {
    this.initializeGoToNextTab();
  }

  private home() {
    this.router.navigate(['/ficha']);
  }

  private getParcelaFlexivel(): void {
    this.parametroParcelaService.getParametroParcela().subscribe({
      next: (res) => {
        const lista: ParametroParcela[] = Array.isArray(res?.parameters)
          ? res.parameters: [];
        const idLojista: number =
          this.lojistaId != null
            ? this.lojistaId
            : Number(this.fichaCadastro?.IDLojista ?? 0);
        const produto = this.getProduto(this.fichaCadastro?.tipoVeiculo);
        this.parametros =
          lista?.find(
            (p) =>
              p.agent === this.loginStorage?.agente?.id  &&
              p.shopkeeper === idLojista &&
              p.modality === this.fichaCadastro?.grupo1 &&
              p.product === produto
          ) ?? null;
        if (!this.parametros) { 
          this.pagamentoFlexivel = false; 
          return; 
        }
        if(this.parametros.decennial === 'N' && 
          this.parametros.monthly === 'N' && 
          this.parametros.biweekly === 'N' && 
          this.parametros.weekly === 'N') {
          this.pagamentoFlexivel = false; 
          return; 
        }
        this.pagamentoFlexivel = lista.some((p) => p.flexiblePayment === true);
      },
      error: () => {
        this.modalMessage.show('Falha na comunicação, verifique sua conexão.');
        this.pagamentoFlexivel = false;
      },
    });
  }
  
 onParcelaSelecionada(selecionou: boolean): void {
    this.isParcelaSelecionada = selecionou;
  }

 getProduto(produto: string): string {
    const mapProduto: Record<string, string> = {
      [TipoVeiculoEnum.AUTOMOVEIS]: SimuladorVeiculoTipoVeiculoEnum.AUTOMOVEIS,
      [TipoVeiculoEnum.MOTOCICLETAS]: SimuladorVeiculoTipoVeiculoEnum.MOTOCICLETAS,
      [TipoVeiculoEnum.PESADOS]: SimuladorVeiculoTipoVeiculoEnum.PESADOS,
    };

    return mapProduto[produto] ?? '';
  }

}
 